import {SuspenseLoader} from '@orbit-ui/components/loader';
import {cn} from '@orbit-ui/core';
import * as React from 'react';
import {type PropsWithSlots} from '@/types/props-with-slots';

type NoShellProps = PropsWithSlots<{
  main: React.ElementType;
  background?: React.ElementType;
  footer?: React.ElementType;
}>;

function NoShell({slots}: NoShellProps) {
  const Main = slots?.main ?? React.Fragment;
  const Background = slots?.background ?? React.Fragment;
  const Footer = slots?.footer ?? React.Fragment;

  return (
    <div>
      <div className="absolute inset-0 -z-10">
        <Background />
      </div>
      <div
        className={cn(
          'grid h-screen grid-cols-1 grid-rows-[auto,1fr,auto]',
          'bg-muted/20 text-foreground',
        )}
      >
        <div>
          <SuspenseLoader>
            <Main />
          </SuspenseLoader>
        </div>
        <div className="z-[1000000000]">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export {NoShell};
